import { ComponentType } from 'react';
import * as ReactPhoneInputModule from 'react-phone-input-material-ui';
import type { PhoneInputProps } from 'react-phone-input-material-ui';

// react-phone-input-material-ui's .d.ts declares a plain default export, but the
// actual built module nests it two levels deep (a named ReactPhoneInput export
// that is itself another ES module namespace with its own .default) -- a
// mismatch/build artifact in the package itself. Reach past the wrong types once,
// here, so every consumer gets a correctly-typed component instead of re-deriving
// this cast at each usage site.
const ReactPhoneInput = (ReactPhoneInputModule as unknown as { ReactPhoneInput: { default: ComponentType<PhoneInputProps> } })
    .ReactPhoneInput.default;

export default ReactPhoneInput;
